export enum EventTrackingEnum {
  SP_NDIS_PRICE_LIMIT_ALERT_MAX_AGREED_RATE_EXPLAINER_ACCORDION_OPENED = 'sp_ndis_price_limit_alert_max_agreed_rate_explainer_accordion_opened',
  SP_RATE_DETAILS_UPDATED = 'sp_rate_details_updated',
  JOBPOST_STARTED = 'Jobpost Started',
  JOBPOST_COMPLETED = 'Jobpost Completed',
  JOBTYPE_SELECTION = 'Jobtype Selection',
  JOBPOST_SUPPORT_ACTIVITIES = 'Jobpost Support Activities',
  JOBPOST_SERVICES_SOCIAL_SUPPORT = 'Jobpost Services Social Support',
  JOBPOST_SERVICES_ALLIED_HEALTH = 'Jobpost Services Allied Health',
  JOBPOST_SERVICES_PERSONAL_CARE = 'Jobpost Services Personal Care',
  JOBPOST_SUPPORT_LOCATION = 'Jobpost Support Location',
  JOBPOST_FREQUENCY_DATES_TIMES = 'Jobpost Frequency Dates Times',
  JOBPOST_SUPPORT_DETAILS = 'Jobpost Support Details',
  JOBPOST_PREFERENCES = 'Jobpost Preferences',
  JOBPOST_PREVIEW = 'Jobpost Preview',
  JOBPOST_SERVICES_LIGHT_HOUSEWORK = 'Jobpost Services Light Housework',
  JOBPOST_SERVICES_SOCIAL_AND_COMMUNITY = 'Jobpost Services Social And Community',
  JOBPOST_SERVICES_TRANSPORT = 'Jobpost Services Transport',
  JOBS_SEARCHED = 'Jobs Searched',
  FIRST_JOBPOST_COMPLETED = 'First Jobpost Completed',
  WORKERS_SEARCHED = 'SPs Searched',
  SP_TIMESHEET_SUBMITTED = 'Support Session Submitted',
  JOB_VIEWED = 'Job Viewed',
  PLANNED_SESSION_CHECKED_IN = 'planned_session_checked_in',
  PLANNED_SESSION_CHECKED_IN_DIFFERENT_TIME = 'planned_session_checked_in_different_time',
  PLANNED_SESSION_CHECKED_OUT_DIFFERENT_TIME = 'planned_session_checked_out_different_time',
  PLANNED_SESSION_CHECKED_OUT = 'planned_session_checked_out',
  PLANNED_SESSION_UNDO_CHECKIN = 'planned_session_undo_check_in',
  PLANNED_SESSION_CICO_OPTED_IN = 'planned_session_cico_opted_in',
  PLANNED_SESSION_CICO_OPTED_OUT = 'planned_session_cico_opted_out',
  PLANNED_SESSION_RECOMMENDED_WORKERS_FOR_REMATCHING_ACCESSED = 'Recommended Workers for Rematching Accessed',
  CICO_NOTIFICATIONS_FOR_ALL_SESSIONS_DECLINED = 'cico_notifications_for_all_sessions_declined',
  CICO_NOTIFICATIONS_FOR_ALL_SESSIONS_ACCEPTED = 'cico_notifications_for_all_sessions_accepted',
  SIGNUP_STARTED = 'Signup Started',
  SIGNUP_COMPLETED = 'Signup Completed',
  SIGNUP_STEP_COMPLETED = 'Signup Step Completed',
  LOGGED_IN = 'Logged In',
  PLANNED_SESSION_DELETED = 'Planned session deleted',
  PLANNED_SESSION_EDITED = 'Planned session edited',
  SESSION_PLANNED = 'Session Planned',
  AGREED_SESSION_PLANNED = 'Agreed Session Planned',
}

export enum SupportHoursEventTrackingEnum {
  DELIVERED_SESSION_CREATED = 'Delivered session created',
  DELIVERED_SESSION_EDITED = 'Delivered session edited',
  DELIVERED_SESSION_DELETED = 'Delivered session deleted',
  DELIVERED_SESSION_MANUALLY_LINKED_TO_EXISTING_PLANNED_SESSION = 'Delivered session manually linked to existing planned session',
  SUPPORT_HOURS_REJECTED = 'Support Hours Rejected',
  SUPPORT_HOURS_APPROVED = 'Support Session Approved',
  SERVICES_INDIVIDUALLY_APPROVED_OR_REJECTED = 'Services individually approved or rejected',
  SUPPORT_HOURS_BULK_APPROVED = 'Support hours bulk approved',
}
